module.exports = __webpack_public_path__ + "img/logo-copaatahualpa.5ec2bc05.png";